// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue--alert[data-v-e9efac78]{position:fixed;right:2em;top:2em;padding:10px 50px 10px 12px;z-index:2000}@media only screen and (max-width: 767px){.vue--alert[data-v-e9efac78]{right:0;top:0;left:0}}.vue--alert p[data-v-e9efac78]{margin:0}", ""]);
// Exports
module.exports = exports;
